// components/common/ErrorBoundary.js - Catch React render errors gracefully
import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[50vh] flex items-center justify-center p-4">
          <div className="text-center max-w-md">
            <AlertTriangle className="w-12 h-12 text-status-warn mx-auto mb-4" />
            <h2 className="text-xl font-bold text-ink mb-2">Something went wrong</h2>
            <p className="text-mutedink mb-6 text-sm">
              {this.state.error?.message || 'An unexpected error occurred.'}
            </p>
            <button
              onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
              className="flex items-center gap-2 mx-auto px-5 py-2.5 bg-[var(--code-block-bg)] text-white rounded-lg font-medium hover:bg-[var(--code-block-bg)] transition-colors"
            >
              <RotateCcw size={16} /> Reload
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
